<div class="logo">
  <img
    width="64"
    height="64"
    src="assets/img/logo_no_circle.svg"
    alt="Care4Giver Logo"
  />
</div>
